import React from "react";
import { useSelector } from "react-redux";
import styles from "./Header.module.css";
import { NoteActions } from "./components";
import { CustomTooltip } from "../../../../../../../../common/components";

const Header = ({ debouncedUpdateNote, forceNoteCreation, onSetNoteStatus }) => {
	const selectedNote = useSelector(({ note }) => note.selectedNote);
	return (
		<div className={styles.container}>
			{selectedNote?.id && !forceNoteCreation && (
				<div className={styles.noteSelection__container}>
					<CustomTooltip showWhenOverflow title={selectedNote?.title}>
						<span className={styles.title}>{selectedNote?.title}</span>
					</CustomTooltip>
					<NoteActions debouncedUpdateNote={debouncedUpdateNote} onSetNoteStatus={onSetNoteStatus} />
				</div>
			)}
		</div>
	);
};

export default Header;
